import { render, staticRenderFns } from "./hyjb.vue?vue&type=template&id=60fe486a"
import script from "./hyjb.vue?vue&type=script&lang=js"
export * from "./hyjb.vue?vue&type=script&lang=js"
import style0 from "./hyjb.vue?vue&type=style&index=0&id=60fe486a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports